/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import { getError } from "Utils/helpers";

// react-router-dom components
import { useNavigate } from "react-router-dom";

function ErrorPage() {
  const [error, setError] = useState(null);

  let navigate = useNavigate();
  const routeChange = () => {
    // let path = `/feed-settings/templates/${templateId}/filters-list`;
    let path = `/dashboard`;
    navigate(path);
  };

  useEffect(() => {
    if (!error) routeChange();
  }, [error]);

  useEffect(() => {
    let tmpError = getError();
    if (!tmpError) routeChange();
    setError(JSON.parse(tmpError));
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <Skill90GlobeGlobe
        display={{ xs: "none", md: "block" }}
        position="absolute"
        top="10%"
        right={0}
        mt={{ xs: -12, lg: 1 }}
        mr={{ xs: 0, lg: 10 }}
        canvasStyle={{ marginTop: "3rem" }}
      /> */}
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                {error && error.message ? error.message : " "}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
ErrorPage.propTypes = {};

export default ErrorPage;
